"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetUserProfile = exports.startAnonymousLogin = exports.startPwdLessVerify = exports.startPwdLessLogin = exports.startResetPassword = exports.startForgotPasswordRequest = exports.startConfirmUser = exports.startRegisterWithPassword = exports.startLogout = exports.startLogin = exports.redirectAfterLogin = exports.logout = exports.reset = exports.forgot = exports.login = exports.setShowUserInfoPerm = void 0;
const application_config_1 = __importDefault(require("../config/application.config"));
const user_1 = require("../services/auth/user");
const auth_1 = require("../store/auth");
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
// Required permissions to show user information in the header menu. For some basic user roles, like anonymous users, user information may not be wanted.
let showUserInfoPerm = undefined;
const setShowUserInfoPerm = (perms) => (showUserInfoPerm = perms);
exports.setShowUserInfoPerm = setShowUserInfoPerm;
const login = (user, isAuthenticated = false, register = false, login = false) => ({
    type: auth_1.AuthActionTypes.LOGIN,
    user: user ? (0, user_1.toCliUser)(user, application_config_1.default.pages, showUserInfoPerm) : user,
    isAuthenticated,
    register,
    login
});
exports.login = login;
const forgot = (forgot = true, emailExists = false, message = '') => ({
    type: auth_1.AuthActionTypes.FORGOT,
    forgot,
    emailExists,
    message
});
exports.forgot = forgot;
const reset = (status = '') => ({
    type: auth_1.AuthActionTypes.RESET,
    status
});
exports.reset = reset;
const logout = () => ({
    type: auth_1.AuthActionTypes.LOGOUT,
    user: null,
    isAuthenticated: false,
    register: false
});
exports.logout = logout;
const redirectAfterLogin = (user, location, navigate) => {
    const requestedPath = location && location.state && location.state.referrer ? location.state.referrer : undefined;
    return navigate(requestedPath ? requestedPath : user.homePage ? user.homePage : application_config_1.default.homePage);
};
exports.redirectAfterLogin = redirectAfterLogin;
// FIXME: Type the callback, it is called in a dispatch, so it needs to be a redux action
// FIXME2: See if our usage of the navigate function is correct or if we should switch to a history, compatible with the new versions of the react-router or let other components or the server do the redirect.
const startLogin = (data, location, navigate, callback) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch('/login', {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                const { user } = yield response.json();
                if (user) {
                    dispatch((0, exports.login)(user, true, false, true));
                    if (typeof callback === 'function') {
                        dispatch(callback());
                    }
                    return (0, exports.redirectAfterLogin)(user, location, navigate);
                }
                else {
                    dispatch((0, exports.login)(null, false, false, true));
                }
            }
            else if (response.status === 401) {
                dispatch((0, exports.login)(null, false, false, true));
                // Unconfirmed user, redirect to proper page
                return navigate('/unconfirmed');
            }
            else {
                // Any other response status should not authenticate but still give feedback to the user
                dispatch((0, exports.login)(null, false, false, true));
                console.error('Error trying to log in: ', response);
            }
        }
        catch (err) {
            console.log('Error logging in.', err);
        }
    });
};
exports.startLogin = startLogin;
const startLogout = (navigate) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch('/logout', { credentials: 'include' });
            if (response.status === 200) {
                const body = yield response.json();
                if (body.loggedOut === true) {
                    dispatch((0, exports.logout)());
                    return navigate('/login');
                }
            }
            else if (response.status === 401) {
                //return { user: null };
                // not authorized (user authentication failed)
            }
        }
        catch (err) {
            console.log('Error logging out.', err);
        }
    });
};
exports.startLogout = startLogout;
const startRegisterWithPassword = (data, location, navigate, callback) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch('/register', {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                const { user } = yield response.json();
                if (user) {
                    dispatch((0, exports.login)(user, true, true, false));
                    if (typeof callback === 'function') {
                        dispatch(callback());
                    }
                    return (0, exports.redirectAfterLogin)(user, location, navigate);
                }
                else {
                    dispatch((0, exports.login)(null, false, true, false));
                }
            }
            else if (response.status === 401) {
                // Unconfirmed user, redirect to proper page
                dispatch((0, exports.login)(null, false, true, false));
                return navigate('/unconfirmed');
            }
            else {
                dispatch((0, exports.login)(null, false, true, false));
            }
        }
        catch (error) {
            console.log('Error during registration.', error);
            dispatch((0, exports.login)(null, false, true, false));
        }
    });
};
exports.startRegisterWithPassword = startRegisterWithPassword;
const startConfirmUser = (data, callback) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch('/verify', {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                const body = yield response.json();
                if (typeof callback === 'function') {
                    dispatch(callback(body));
                }
            }
            else {
                if (typeof callback === 'function') {
                    dispatch(callback(null));
                }
            }
        }
        catch (err) {
            console.log('Error during forgot request.', err);
        }
    });
};
exports.startConfirmUser = startConfirmUser;
const startForgotPasswordRequest = (data) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch('/forgot', {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const body = yield response.json();
            if (response.status === 200) {
                dispatch((0, exports.forgot)(true, body.emailExists, body.error));
            }
            else {
                console.error('Server returned an error during forgot request.', body.error);
                dispatch((0, exports.forgot)(true, undefined, 'cannot get response'));
            }
        }
        catch (err) {
            console.error('Error during forgot request.', err);
            dispatch((0, exports.forgot)(true, undefined, JSON.stringify(err)));
        }
    });
};
exports.startForgotPasswordRequest = startForgotPasswordRequest;
const startResetPassword = (data) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch(`/reset/${data.token}`, {
                method: 'POST',
                body: data.password ? JSON.stringify({ newPassword: data.password }) : undefined,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const body = yield response.json();
            dispatch((0, exports.reset)(body.status));
        }
        catch (err) {
            console.log('Error during password change.', err);
            dispatch((0, exports.reset)('Error'));
        }
    });
};
exports.startResetPassword = startResetPassword;
const startPwdLessLogin = (data, location, navigate, callback) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const requestBody = Object.assign({}, data);
            if (location && location.state && location.state.referrer) {
                requestBody.referrer = location.state.referrer;
            }
            const response = yield fetch('/pwdless', {
                method: 'POST',
                body: JSON.stringify(requestBody),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                const json = yield response.json();
                const { user, success } = json;
                if (user) {
                    // Direct login after entering email or sms
                    dispatch((0, exports.login)(user, true, true, false));
                    if (typeof callback === 'function') {
                        dispatch(callback());
                    }
                    // TODO this should be configurable
                    return (0, exports.redirectAfterLogin)(user, location, navigate);
                }
                else if (success === true) {
                    return navigate('/checkMagicEmail');
                }
                else {
                    dispatch((0, exports.login)(null, false, false, true));
                }
            }
            else {
                // Any other response status should not authenticate but still give feedback to the user
                dispatch((0, exports.login)(null, false, false, true));
                console.error('Error trying to log in: ', response);
            }
        }
        catch (err) {
            console.log('Error logging in.', err);
        }
    });
};
exports.startPwdLessLogin = startPwdLessLogin;
const startPwdLessVerify = (token, location, navigate, callback) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch(`/pwdless/verify?token=${token}`, {
                method: 'GET',
                credentials: 'include'
            });
            if (response.status === 200) {
                const { user, referrer } = yield response.json();
                if (user) {
                    dispatch((0, exports.login)(user, true, false, true));
                    if (typeof callback === 'function') {
                        dispatch(callback());
                    }
                    if (referrer) {
                        return navigate(referrer);
                    }
                    else {
                        return (0, exports.redirectAfterLogin)(user, location, navigate);
                    }
                }
                else {
                    dispatch((0, exports.login)(null, false, false, true));
                }
            }
            else {
                // Any other response status should not authenticate but still give feedback to the user
                dispatch((0, exports.login)(null, false, false, true));
                console.error('Error trying to log in: ', response);
            }
        }
        catch (err) {
            console.log('Error logging in.', err);
        }
    });
};
exports.startPwdLessVerify = startPwdLessVerify;
const startAnonymousLogin = (location, navigate, callback) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch('/anonymous', {
                method: 'GET',
                credentials: 'include'
            });
            if (response.status === 200) {
                const { user } = yield response.json();
                if (user) {
                    dispatch((0, exports.login)(user, true, true, false));
                    if (typeof callback === 'function') {
                        dispatch(callback());
                    }
                    return (0, exports.redirectAfterLogin)(user, location, navigate);
                }
                else {
                    dispatch((0, exports.login)(null, false, true, false));
                }
            }
            else {
                // Any other response status should not authenticate but still give feedback to the user
                dispatch((0, exports.login)(null, false, false, true));
                console.error('Error trying to log in: ', response);
            }
        }
        catch (err) {
            dispatch((0, exports.login)(null, false, false, true));
            console.log('Error logging in.', err);
        }
    });
};
exports.startAnonymousLogin = startAnonymousLogin;
const resetUserProfile = (navigate) => {
    return (_dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // reset user pref on server
            const response = yield fetch('/reset_user_preferences', { credentials: 'include' });
            // reset localStorage
            window.localStorage.clear();
            // reload preferences from server
            yield Preferences_1.default.load(ServiceLocator_1.default.socketEventManager);
            if (response.status === 200) {
                const defaultPath = application_config_1.default.homePage;
                return navigate(defaultPath);
            }
        }
        catch (err) {
            console.log('Error reset user.', err);
        }
    });
};
exports.resetUserProfile = resetUserProfile;
//# sourceMappingURL=Auth.js.map